import { render, staticRenderFns } from "./FundraisingGoalRewardCard.vue?vue&type=template&id=7bce0b7b&scoped=true&"
import script from "./FundraisingGoalRewardCard.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalRewardCard.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalRewardCard.vue?vue&type=style&index=0&id=7bce0b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce0b7b",
  null
  
)

export default component.exports